import {visit} from '@manuelpuyol/turbo'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function softNavigate(url: string, turboOptions?: any) {
  visit(url, {...turboOptions})
}
